<template>
  <div :class="['banner', { 'banner--wide': useListView }]" :style="bannerStyle">
    <h2 class="banner__title">
      {{ banner.title }}
    </h2>
    <oie-action-link
      is-type="a"
      :url="banner.cta.href"
      :text="banner.cta.text"
      :targer="banner.cta.target"
      class="banner__link"></oie-action-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    banner: {
      type: Object,
      required: true
    },
    productCount: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('ui', ['useListView']),
    useLargeImage() {
      return this.banner.largeImageUrl && this.mq('large') && this.productCount >= 6
    },
    bannerStyle() {
      let imageSrc = this.banner.defaultImageUrl
      let gridSpan = 'span 1'

      if (this.useListView) {
        imageSrc = this.banner.wideImageUrl
      } else if (this.useLargeImage) {
        imageSrc = this.banner.largeImageUrl
        gridSpan = 'span 2'
      }

      return {
        backgroundImage: `url(${imageSrc})`,
        gridColumn: gridSpan,
        color: this.banner.titleColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  min-height: 400px;
}

.banner--wide {
  min-height: auto;
}

.banner__title {
  @include h1-bold;
  margin-top: 0;
  margin-bottom: 1rem;

  @include media('to-medium') {
    font-size: 2.5rem;
    word-break: break-word;
    margin-bottom: 2rem;
  }
}

.banner__link {
  @include body-semi-bold;
  background-color: color(button-action-blue);
  color: color(text-inverted);
  box-shadow: inset 0 -0.4375rem color(button-action-border-blue);

  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.125rem;
  padding: 0 measure(half);
  border: none;
  text-decoration: none;
  transition: all 140ms ease-in;

  &:hover {
    background-color: color(button-action-border-blue);
    box-shadow: inset 0 -0.4375rem color(button-action-blue);
    transition: all 140ms ease-out;
    cursor: pointer;
  }
}
</style>
